import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {RelatedBusinessProcessConfig} from '../../Models/relatedBusinessProcessConfig';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAllMetadataStructures() {
    return this.http.get<any[]>('/api/metadata/getAllStructures');
  }

  saveMetadataStructure(metadataStructure) {
    return this.http.post<any>('api/metadata/saveStructure', metadataStructure);
  }

  deleteMetadataStructure(metadataStructure) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: { },
    };
    return this.http.delete(`api/metadata/removeStructure/${metadataStructure.metadataStructureId}/${metadataStructure.name}`, options);
  }

  getAllMetadataEditingByAdmin(userId) {
    return this.http.get<any[]>(`/api/metadata/getAllEditingByAdmin/${userId}`);
  }

  saveUserMetadataValueByAdmin(userId, metadataObjectValue) {
    return this.http.post<any>(`api/metadata/saveUserMetadataValueByAdmin/${userId}`, metadataObjectValue);
  }
}
